/**
 * <quick-add-popup> — dynamic colour switching for mobile quick add
 *
 * Swatch click fetches the target colour's card via the Section
 * Rendering API and swaps element's contents in place, leaving the
 * open <modal-dialog> untouched.
 */
class QuickAddPopup extends HTMLElement {
  connectedCallback() {
    if (this.bound) return; // listener on `this`, which survives swaps
    this.bound = true;
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const swatch = event.target.closest('a.color-swatch');
    if (!swatch) return;
    event.preventDefault();
    if (this.loading || swatch.classList.contains('is-active')) return;
    this.swap(swatch);
  }

  swap(swatch) {
    const href = swatch.getAttribute('href');
    const url = href.split('?')[0] + '?section_id=product-card';
    this.loading = true;
    this.classList.add('is-loading');

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`Section fetch failed (${res.status})`);
        return res.text();
      })
      .then((html) => {
        const body = new DOMParser().parseFromString(html, 'text/html').querySelector('.quick-add__popup-body');
        if (!body) throw new Error('No popup body in fetched card');

        // Cache swatches, change active, re-inject to preserve swatch order
        const keptSwatches = this.querySelector('.quick-add__popup-swatches');
        keptSwatches
          ?.querySelectorAll('a.color-swatch')
          .forEach((el) => el.classList.toggle('is-active', el === swatch));

        this.innerHTML = body.innerHTML; // refresh details, colour label, sizes, ATC + BIS json

        const freshSwatches = this.querySelector('.quick-add__popup-swatches');
        if (keptSwatches && freshSwatches) {
          freshSwatches.before(keptSwatches);
          freshSwatches.remove();
        }

        this.loading = false;
        this.classList.remove('is-loading');
      })
      .catch((error) => {
        console.error('[quick-add-popup] swap failed, falling back to PDP', error);
        window.location = href; // graceful fallback: navigate to colour product
      });
  }
}

if (!customElements.get('quick-add-popup')) {
  customElements.define('quick-add-popup', QuickAddPopup);
}
